import { Flex } from '@applyboard/crystal-ui';

import { ProgramDetailsHeading } from '../components/ProgramDetailsHeading';
import { ProgramInformation } from '../components/ProgramInformation';
import { useState } from 'react';

export function MobileLayout() {
  const [allowedToEdit, setAllowedToEdit] = useState(false);

  return (
    <Flex p={4} gap={4} direction="column">
      <ProgramDetailsHeading allowedToEdit={allowedToEdit} setAllowedToEdit={setAllowedToEdit} />
      <ProgramInformation allowedToEdit={allowedToEdit} setAllowedToEdit={setAllowedToEdit} />
    </Flex>
  );
}
